angular.module('mercury.modules.stock.menu')
.config(["$stateProvider", function($stateProvider) {
  $stateProvider.state('Stock.Menu', {
    url: '/menus',
    templateUrl: 'modules/stock/menu/list.tpl.html',
    controller: 'StockMenuListCtrl',
    data: {
      menuLinkState: 'Stock.Menu'
    }
  });

  $stateProvider.state('Stock.MenuAdd', {
    url: '/menus/add',
    templateUrl: 'modules/stock/menu/edit.tpl.html',
    controller: 'StockMenuEditCtrl',
    data: {
      menuLinkState: 'Stock.Menu'
    }
  });

  $stateProvider.state('Stock.MenuEdit', {
    url: '/menus/edit/:id',
    templateUrl: 'modules/stock/menu/edit.tpl.html',
    controller: 'StockMenuEditCtrl',
    data: {
      menuLinkState: 'Stock.Menu'
    }
  });

  $stateProvider.state('Stock.MenuView', {
    url: '/menus/view/:id',
    templateUrl: 'modules/stock/menu/view.tpl.html',
    controller: 'StockMenuViewCtrl',
    data: {
      menuLinkState: 'Stock.Menu'
    }
  });

  $stateProvider.state('Stock.MenuIngredients', {
    url: '/menus/ingredients/:id',
    templateUrl: 'modules/stock/menu/ingredient.tpl.html',
    controller: 'StockMenuIngredientCtrl',
    data: {
      menuLinkState: 'Stock.Menu'
    }
  });

  $stateProvider.state('Stock.MenuPrintRecipes', {
    url: '/menus/recipes/:id',
    templateUrl: 'modules/stock/menu/printrecipes.tpl.html',
    controller: 'StockMenuPrintrecipesCtrl',
    data: {
      menuLinkState: 'Stock.Menu'
    }
  });

  // React Routes
  //
  // - note once we retire the AngularJS route we can rename these
  // to be '/menus' and the AngularJS ones can be called something
  // like '/old-menus' until we remove it
  $stateProvider.state('Stock.Menus', {
    url: '/all-menus',
    controller: 'ReactCtrl',
    data: {
      menuLinkState: 'Stock.Menus'
    }
  });
  $stateProvider.state('Stock.MenuEditReact', {
    url: '/all-menus/:menuId',
    controller: 'ReactCtrl',
    data: {
      menuLinkState: 'Stock.Menus'
    }
  });
  $stateProvider.state('Stock.MenuCreateReact', {
    url: '/all-menus/create',
    controller: 'ReactCtrl',
    data: {
      menuLinkState: 'Stock.Menus'
    }
  });
}]);
